import { createFacebookHomeBlock, createInstagramHomeBlock, createYoutubeHomeBlock, createtwitterHomeBlock, switchLoading , erreurBlock } from './mur_social/block';

let pageUrl = $('body').data('page-url');

fetch(`${pageUrl}/controller/markal/homeReseauxSociaux`)
.then(res => res.json())
.then(jsonData => {
    let facebook = "";
    let instagrams = "";
    let youtube = "";
    let twitter = "";

    let facebookNb = 0;
    let instagramNb = 0;
    let youtubeNb = 0;
    let twitterNb = 0;

    if(jsonData.facebook){
        facebook = (jsonData.facebook[0] ? createFacebookHomeBlock(jsonData.facebook[0]) : null);
        facebookNb = jsonData.facebook.length;
    }
    
    if(jsonData.instagram){
        let current = 1;
        jsonData.instagram.forEach(e => {
            instagrams += createInstagramHomeBlock(e, current);
            current++;
        });
        instagramNb = jsonData.instagram.length
    }
    
    if(jsonData.youtube){
        youtube = (jsonData.youtube.length > 0 ? createYoutubeHomeBlock(jsonData.youtube[0]) : null);
        youtubeNb = jsonData.youtube.length
    }

    if(jsonData.twitter){
        twitter = (jsonData.twitter.length > 0 ? createtwitterHomeBlock(jsonData.twitter[0]) : null);
        twitterNb = jsonData.twitter.length
    }

    let reseauSociauxBlock = $('#reseau_sociaux');



    if(youtube !== null){
        reseauSociauxBlock.append(youtube)
    }

    if(facebook !== null){
            reseauSociauxBlock.append(facebook)
    }

    if(twitter !== null){
        reseauSociauxBlock.append(twitter)
    }

    if(instagrams !== null){
            reseauSociauxBlock.append(instagrams)
    }

    switchLoading();

    if(facebookNb === 0 && instagramNb === 0 && twitterNb === 0 && youtubeNb === 0){
        reseauSociauxBlock.append(erreurBlock(reseauSociauxBlock.data('error-message')));
    }
})